import { render, staticRenderFns } from "./TextButton.vue?vue&type=template&id=1b5d5ceb&"
import script from "./TextButton.vue?vue&type=script&lang=js&"
export * from "./TextButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports